var map = {
	"./Pages/agents/agent-report": [
		617,
		9,
		27
	],
	"./Pages/agents/agent-report.jsx": [
		617,
		9,
		27
	],
	"./Pages/agents/agents-earning": [
		652,
		9,
		105
	],
	"./Pages/agents/agents-earning.jsx": [
		652,
		9,
		105
	],
	"./Pages/agents/attendance_report_details": [
		570,
		9,
		109
	],
	"./Pages/agents/attendance_report_details.jsx": [
		570,
		9,
		109
	],
	"./Pages/agents/attendance_report_summary": [
		571,
		9,
		110
	],
	"./Pages/agents/attendance_report_summary.jsx": [
		571,
		9,
		110
	],
	"./Pages/agents/call-disposition-analysis": [
		640,
		9,
		40
	],
	"./Pages/agents/call-disposition-analysis.jsx": [
		640,
		9,
		40
	],
	"./Pages/agents/details_report": [
		581,
		9,
		59
	],
	"./Pages/agents/details_report.jsx": [
		581,
		9,
		59
	],
	"./Pages/agents/manage-agents": [
		620,
		9,
		61
	],
	"./Pages/agents/manage-agents.jsx": [
		620,
		9,
		61
	],
	"./Pages/agents/summary_report": [
		582,
		9,
		60
	],
	"./Pages/agents/summary_report.jsx": [
		582,
		9,
		60
	],
	"./Pages/analytics/alt-number-report": [
		583,
		9,
		111
	],
	"./Pages/analytics/alt-number-report.jsx": [
		583,
		9,
		111
	],
	"./Pages/analytics/perfomance-summary": [
		618,
		9,
		15
	],
	"./Pages/analytics/perfomance-summary.jsx": [
		618,
		9,
		15
	],
	"./Pages/call-quality/CallQualityDayWiseAuditor": [
		572,
		9,
		112
	],
	"./Pages/call-quality/CallQualityDayWiseAuditor.jsx": [
		572,
		9,
		112
	],
	"./Pages/call-quality/agent-report": [
		665,
		9,
		44
	],
	"./Pages/call-quality/agent-report-summary": [
		573,
		9,
		113
	],
	"./Pages/call-quality/agent-report-summary.jsx": [
		573,
		9,
		113
	],
	"./Pages/call-quality/agent-report.jsx": [
		665,
		9,
		44
	],
	"./Pages/call-quality/audit-calls": [
		647,
		9,
		0,
		2,
		114
	],
	"./Pages/call-quality/audit-calls.jsx": [
		647,
		9,
		0,
		2,
		114
	],
	"./Pages/call-quality/auditor-report": [
		666,
		9,
		16
	],
	"./Pages/call-quality/auditor-report-summary": [
		574,
		9,
		115
	],
	"./Pages/call-quality/auditor-report-summary.jsx": [
		574,
		9,
		115
	],
	"./Pages/call-quality/auditor-report.jsx": [
		666,
		9,
		16
	],
	"./Pages/call-quality/daily-report-get-call-percent": [
		575,
		9,
		116
	],
	"./Pages/call-quality/daily-report-get-call-percent.jsx": [
		575,
		9,
		116
	],
	"./Pages/call-quality/daily-report-summary": [
		569,
		9,
		117
	],
	"./Pages/call-quality/daily-report-summary.jsx": [
		569,
		9,
		117
	],
	"./Pages/call-quality/day-report": [
		653,
		9,
		19
	],
	"./Pages/call-quality/day-report.jsx": [
		653,
		9,
		19
	],
	"./Pages/call-quality/dispositionByAgents": [
		576,
		9,
		118
	],
	"./Pages/call-quality/dispositionByAgents.jsx": [
		576,
		9,
		118
	],
	"./Pages/call-quality/month-report": [
		667,
		9,
		20
	],
	"./Pages/call-quality/month-report.jsx": [
		667,
		9,
		20
	],
	"./Pages/call-quality/monthly-report-summary": [
		577,
		9,
		119
	],
	"./Pages/call-quality/monthly-report-summary.jsx": [
		577,
		9,
		119
	],
	"./Pages/campaigns/campaign-plan": [
		584,
		9,
		106
	],
	"./Pages/campaigns/campaign-plan.jsx": [
		584,
		9,
		106
	],
	"./Pages/campaigns/campaign-status": [
		627,
		9,
		28
	],
	"./Pages/campaigns/campaign-status.jsx": [
		627,
		9,
		28
	],
	"./Pages/campaigns/create-single-campaign": [
		585,
		9,
		102
	],
	"./Pages/campaigns/create-single-campaign.jsx": [
		585,
		9,
		102
	],
	"./Pages/campaigns/digital-report": [
		668,
		9,
		66
	],
	"./Pages/campaigns/digital-report.jsx": [
		668,
		9,
		66
	],
	"./Pages/campaigns/ivr-restart-summary": [
		586,
		9,
		120
	],
	"./Pages/campaigns/ivr-restart-summary.jsx": [
		586,
		9,
		120
	],
	"./Pages/campaigns/manage": [
		615,
		9,
		24
	],
	"./Pages/campaigns/manage.jsx": [
		615,
		9,
		24
	],
	"./Pages/campaigns/notice-campaign-report": [
		587,
		9,
		76
	],
	"./Pages/campaigns/notice-campaign-report.jsx": [
		587,
		9,
		76
	],
	"./Pages/campaigns/summary": [
		669,
		9,
		93
	],
	"./Pages/campaigns/summary.jsx": [
		669,
		9,
		93
	],
	"./Pages/chat-panel/alt-chat": [
		670,
		9,
		1,
		4,
		121
	],
	"./Pages/chat-panel/alt-chat.jsx": [
		670,
		9,
		1,
		4,
		121
	],
	"./Pages/chat-panel/chat": [
		654,
		9,
		1,
		4,
		122
	],
	"./Pages/chat-panel/chat.jsx": [
		654,
		9,
		1,
		4,
		122
	],
	"./Pages/chat-panel/email": [
		622,
		9,
		1,
		91
	],
	"./Pages/chat-panel/email.jsx": [
		622,
		9,
		1,
		91
	],
	"./Pages/clients/borrower-info-mapping": [
		429,
		9,
		3
	],
	"./Pages/clients/borrower-info-mapping/": [
		429,
		9,
		3
	],
	"./Pages/clients/borrower-info-mapping/index": [
		429,
		9,
		3
	],
	"./Pages/clients/borrower-info-mapping/index.jsx": [
		429,
		9,
		3
	],
	"./Pages/clients/borrower-info-mapping/style.module.css": [
		1015,
		7,
		138
	],
	"./Pages/clients/client-poc": [
		671,
		9,
		62
	],
	"./Pages/clients/client-poc.jsx": [
		671,
		9,
		62
	],
	"./Pages/clients/features-settings": [
		641,
		9,
		50
	],
	"./Pages/clients/features-settings.jsx": [
		641,
		9,
		50
	],
	"./Pages/clients/manage-clients": [
		619,
		9,
		94
	],
	"./Pages/clients/manage-clients.jsx": [
		619,
		9,
		94
	],
	"./Pages/clients/process": [
		628,
		9,
		134,
		22
	],
	"./Pages/clients/process.jsx": [
		628,
		9,
		134,
		22
	],
	"./Pages/collection-perfomance/batch-report": [
		672,
		9,
		45
	],
	"./Pages/collection-perfomance/batch-report.jsx": [
		672,
		9,
		45
	],
	"./Pages/collection-perfomance/collection-report": [
		616,
		9,
		31
	],
	"./Pages/collection-perfomance/collection-report.jsx": [
		616,
		9,
		31
	],
	"./Pages/collection-perfomance/leads": [
		655,
		9,
		30
	],
	"./Pages/collection-perfomance/leads.jsx": [
		655,
		9,
		30
	],
	"./Pages/collection-perfomance/legal-calling-mis": [
		673,
		9,
		37
	],
	"./Pages/collection-perfomance/legal-calling-mis.jsx": [
		673,
		9,
		37
	],
	"./Pages/collection-perfomance/recovery-rate": [
		674,
		9,
		67
	],
	"./Pages/collection-perfomance/recovery-rate.jsx": [
		674,
		9,
		67
	],
	"./Pages/collection-perfomance/style.module.css": [
		1012,
		7,
		139
	],
	"./Pages/collection/batch": [
		629,
		9,
		89
	],
	"./Pages/collection/batch.jsx": [
		629,
		9,
		89
	],
	"./Pages/daily-ops/CallQualitySummary": [
		578,
		9,
		123
	],
	"./Pages/daily-ops/CallQualitySummary.jsx": [
		578,
		9,
		123
	],
	"./Pages/daily-ops/admin-apis": [
		609,
		9,
		5,
		13
	],
	"./Pages/daily-ops/admin-apis.jsx": [
		609,
		9,
		5,
		13
	],
	"./Pages/daily-ops/call-quality": [
		675,
		9,
		0,
		2,
		107
	],
	"./Pages/daily-ops/call-quality.jsx": [
		675,
		9,
		0,
		2,
		107
	],
	"./Pages/daily-ops/chat-panel-report": [
		588,
		9,
		48
	],
	"./Pages/daily-ops/chat-panel-report.jsx": [
		588,
		9,
		48
	],
	"./Pages/daily-ops/custom-link-reports": [
		676,
		9,
		124
	],
	"./Pages/daily-ops/custom-link-reports.jsx": [
		676,
		9,
		124
	],
	"./Pages/daily-ops/custom-payment-links": [
		677,
		9,
		125
	],
	"./Pages/daily-ops/custom-payment-links.jsx": [
		677,
		9,
		125
	],
	"./Pages/daily-ops/dnd-list": [
		656,
		9,
		56
	],
	"./Pages/daily-ops/dnd-list.jsx": [
		656,
		9,
		56
	],
	"./Pages/daily-ops/email-panel-report": [
		589,
		9,
		49
	],
	"./Pages/daily-ops/email-panel-report.jsx": [
		589,
		9,
		49
	],
	"./Pages/daily-ops/escalation-module": [
		678,
		9,
		0,
		14
	],
	"./Pages/daily-ops/escalation-module.jsx": [
		678,
		9,
		0,
		14
	],
	"./Pages/daily-ops/exophone-change-report": [
		679,
		9,
		92
	],
	"./Pages/daily-ops/exophone-change-report.jsx": [
		679,
		9,
		92
	],
	"./Pages/daily-ops/exophone-management": [
		648,
		9,
		77
	],
	"./Pages/daily-ops/exophone-management.jsx": [
		648,
		9,
		77
	],
	"./Pages/daily-ops/file-upload-report": [
		633,
		9,
		21
	],
	"./Pages/daily-ops/file-upload-report.jsx": [
		633,
		9,
		21
	],
	"./Pages/daily-ops/gupshup-mapping-summary": [
		590,
		9,
		95
	],
	"./Pages/daily-ops/gupshup-mapping-summary.jsx": [
		590,
		9,
		95
	],
	"./Pages/daily-ops/gupshup-mappings": [
		630,
		9,
		86
	],
	"./Pages/daily-ops/gupshup-mappings.jsx": [
		630,
		9,
		86
	],
	"./Pages/daily-ops/meta-mappings": [
		631,
		9,
		87
	],
	"./Pages/daily-ops/meta-mappings-summary": [
		591,
		9,
		96
	],
	"./Pages/daily-ops/meta-mappings-summary.jsx": [
		591,
		9,
		96
	],
	"./Pages/daily-ops/meta-mappings.jsx": [
		631,
		9,
		87
	],
	"./Pages/daily-ops/payment-receipts": [
		642,
		9,
		10
	],
	"./Pages/daily-ops/payment-receipts.jsx": [
		642,
		9,
		10
	],
	"./Pages/daily-ops/search-fir": [
		634,
		9,
		126
	],
	"./Pages/daily-ops/search-fir.jsx": [
		634,
		9,
		126
	],
	"./Pages/daily-ops/settlement-report": [
		592,
		9,
		101
	],
	"./Pages/daily-ops/settlement-report.jsx": [
		592,
		9,
		101
	],
	"./Pages/hr/applicants": [
		621,
		9,
		42
	],
	"./Pages/hr/applicants.jsx": [
		621,
		9,
		42
	],
	"./Pages/hr/candidates": [
		614,
		9,
		43
	],
	"./Pages/hr/candidates.jsx": [
		614,
		9,
		43
	],
	"./Pages/hr/generate-offer-letter": [
		657,
		9,
		70
	],
	"./Pages/hr/generate-offer-letter.jsx": [
		657,
		9,
		70
	],
	"./Pages/hr/manage-jobs": [
		632,
		9,
		97
	],
	"./Pages/hr/manage-jobs.jsx": [
		632,
		9,
		97
	],
	"./Pages/hr/manage-offer-letter": [
		593,
		9,
		98
	],
	"./Pages/hr/manage-offer-letter.jsx": [
		593,
		9,
		98
	],
	"./Pages/invoice/client-setting": [
		594,
		9,
		103
	],
	"./Pages/invoice/client-setting.jsx": [
		594,
		9,
		103
	],
	"./Pages/invoice/email-template": [
		595,
		9,
		127
	],
	"./Pages/invoice/email-template.jsx": [
		595,
		9,
		127
	],
	"./Pages/invoice/generate-invoice": [
		680,
		9,
		68
	],
	"./Pages/invoice/generate-invoice.jsx": [
		680,
		9,
		68
	],
	"./Pages/invoice/invoice-formats": [
		596,
		9,
		128
	],
	"./Pages/invoice/invoice-formats.jsx": [
		596,
		9,
		128
	],
	"./Pages/invoice/manage-invoice": [
		658,
		9,
		78
	],
	"./Pages/invoice/manage-invoice.jsx": [
		658,
		9,
		78
	],
	"./Pages/login": [
		370,
		9
	],
	"./Pages/login.jsx": [
		370,
		9
	],
	"./Pages/others/auto-campaign-mapping": [
		659,
		9,
		41
	],
	"./Pages/others/auto-campaign-mapping.jsx": [
		659,
		9,
		41
	],
	"./Pages/others/cron-management": [
		635,
		9,
		129
	],
	"./Pages/others/cron-management.jsx": [
		635,
		9,
		129
	],
	"./Pages/others/dashboard": [
		681,
		9,
		130
	],
	"./Pages/others/dashboard.jsx": [
		681,
		9,
		130
	],
	"./Pages/others/generate-retention-data": [
		597,
		9,
		29
	],
	"./Pages/others/generate-retention-data.jsx": [
		597,
		9,
		29
	],
	"./Pages/others/openai-analysis": [
		598,
		9,
		88
	],
	"./Pages/others/openai-analysis.jsx": [
		598,
		9,
		88
	],
	"./Pages/others/openai-prompts": [
		660,
		9,
		79
	],
	"./Pages/others/openai-prompts.jsx": [
		660,
		9,
		79
	],
	"./Pages/others/user-module": [
		682,
		9,
		131
	],
	"./Pages/others/user-module.jsx": [
		682,
		9,
		131
	],
	"./Pages/settlements/ACM-RCM": [
		636,
		9,
		69
	],
	"./Pages/settlements/ACM-RCM.jsx": [
		636,
		9,
		69
	],
	"./Pages/settlements/daily-report": [
		649,
		9,
		5,
		36
	],
	"./Pages/settlements/daily-report.jsx": [
		649,
		9,
		5,
		36
	],
	"./Pages/settlements/manage-settlements": [
		612,
		9,
		11
	],
	"./Pages/settlements/manage-settlements.jsx": [
		612,
		9,
		11
	],
	"./Pages/settlements/online-settlements": [
		610,
		9,
		23
	],
	"./Pages/settlements/online-settlements.jsx": [
		610,
		9,
		23
	],
	"./Pages/settlements/report": [
		643,
		9,
		18
	],
	"./Pages/settlements/report.jsx": [
		643,
		9,
		18
	],
	"./Pages/settlements/setl-stage-analysis": [
		599,
		9,
		80
	],
	"./Pages/settlements/setl-stage-analysis.jsx": [
		599,
		9,
		80
	],
	"./Pages/settlements/settlement-analysis": [
		600,
		9,
		81
	],
	"./Pages/settlements/settlement-analysis.jsx": [
		600,
		9,
		81
	],
	"./Pages/templates/add-variable": [
		683,
		9,
		132
	],
	"./Pages/templates/add-variable.jsx": [
		683,
		9,
		132
	],
	"./Pages/templates/email": [
		661,
		9,
		51
	],
	"./Pages/templates/email.jsx": [
		661,
		9,
		51
	],
	"./Pages/templates/gupshup-templates": [
		644,
		9,
		32
	],
	"./Pages/templates/gupshup-templates.jsx": [
		644,
		9,
		32
	],
	"./Pages/templates/ivr": [
		645,
		9,
		90
	],
	"./Pages/templates/ivr.jsx": [
		645,
		9,
		90
	],
	"./Pages/templates/legal-notices": [
		646,
		9,
		38
	],
	"./Pages/templates/legal-notices.jsx": [
		646,
		9,
		38
	],
	"./Pages/templates/manage-category": [
		601,
		9,
		108
	],
	"./Pages/templates/manage-category.jsx": [
		601,
		9,
		108
	],
	"./Pages/templates/meta-templates": [
		637,
		9,
		33
	],
	"./Pages/templates/meta-templates.jsx": [
		637,
		9,
		33
	],
	"./Pages/templates/sms": [
		638,
		9,
		8,
		63
	],
	"./Pages/templates/sms.jsx": [
		638,
		9,
		8,
		63
	],
	"./Pages/templates/wati-accounts-management": [
		639,
		9,
		46
	],
	"./Pages/templates/wati-accounts-management.jsx": [
		639,
		9,
		46
	],
	"./Pages/templates/whatsapp": [
		623,
		9,
		64
	],
	"./Pages/templates/whatsapp.jsx": [
		623,
		9,
		64
	],
	"./Pages/voicebot/ai-recruiter": [
		603,
		9,
		35
	],
	"./Pages/voicebot/ai-recruiter-summary": [
		602,
		9,
		53
	],
	"./Pages/voicebot/ai-recruiter-summary.jsx": [
		602,
		9,
		53
	],
	"./Pages/voicebot/ai-recruiter.jsx": [
		603,
		9,
		35
	],
	"./Pages/voicebot/campaign-detail": [
		664,
		9,
		6
	],
	"./Pages/voicebot/campaign-detail.jsx": [
		664,
		9,
		6
	],
	"./Pages/voicebot/hiring-pipeline": [
		604,
		9,
		54
	],
	"./Pages/voicebot/hiring-pipeline.jsx": [
		604,
		9,
		54
	],
	"./Pages/voicebot/job-detail": [
		663,
		9,
		7
	],
	"./Pages/voicebot/job-detail.jsx": [
		663,
		9,
		7
	],
	"./Pages/voicebot/screening-campaigns": [
		605,
		9,
		55
	],
	"./Pages/voicebot/screening-campaigns.jsx": [
		605,
		9,
		55
	],
	"./Pages/wip/allocation-analysis": [
		662,
		9,
		82
	],
	"./Pages/wip/allocation-analysis.jsx": [
		662,
		9,
		82
	],
	"./Pages/wip/axis-data-count": [
		684,
		9,
		99
	],
	"./Pages/wip/axis-data-count.jsx": [
		684,
		9,
		99
	],
	"./Pages/wip/borrower-report": [
		624,
		9,
		17
	],
	"./Pages/wip/borrower-report.jsx": [
		624,
		9,
		17
	],
	"./Pages/wip/bot-mistake": [
		606,
		9,
		47
	],
	"./Pages/wip/bot-mistake.jsx": [
		606,
		9,
		47
	],
	"./Pages/wip/client-email": [
		685,
		9,
		52
	],
	"./Pages/wip/client-email.jsx": [
		685,
		9,
		52
	],
	"./Pages/wip/conciliation-joining": [
		625,
		9,
		25
	],
	"./Pages/wip/conciliation-joining.jsx": [
		625,
		9,
		25
	],
	"./Pages/wip/daily-projection-report": [
		686,
		9,
		83
	],
	"./Pages/wip/daily-projection-report.jsx": [
		686,
		9,
		83
	],
	"./Pages/wip/excluded-list": [
		687,
		9,
		71
	],
	"./Pages/wip/excluded-list.jsx": [
		687,
		9,
		71
	],
	"./Pages/wip/exotel-campaign-report": [
		688,
		9,
		57
	],
	"./Pages/wip/exotel-campaign-report.jsx": [
		688,
		9,
		57
	],
	"./Pages/wip/fir-working-state": [
		689,
		9,
		72
	],
	"./Pages/wip/fir-working-state.jsx": [
		689,
		9,
		72
	],
	"./Pages/wip/helpline-number-report": [
		690,
		9,
		58
	],
	"./Pages/wip/helpline-number-report.jsx": [
		690,
		9,
		58
	],
	"./Pages/wip/letter-aging-summary": [
		650,
		9,
		26
	],
	"./Pages/wip/letter-aging-summary.jsx": [
		650,
		9,
		26
	],
	"./Pages/wip/litigation-doc": [
		691,
		9,
		73
	],
	"./Pages/wip/litigation-doc.jsx": [
		691,
		9,
		73
	],
	"./Pages/wip/manage-mindue": [
		626,
		9,
		39
	],
	"./Pages/wip/manage-mindue.jsx": [
		626,
		9,
		39
	],
	"./Pages/wip/monthly-allocation-analysis": [
		607,
		9,
		74
	],
	"./Pages/wip/monthly-allocation-analysis.jsx": [
		607,
		9,
		74
	],
	"./Pages/wip/monthly-collector-report": [
		692,
		9,
		104
	],
	"./Pages/wip/monthly-collector-report.jsx": [
		692,
		9,
		104
	],
	"./Pages/wip/outgoing-call-summary": [
		693,
		9,
		100
	],
	"./Pages/wip/outgoing-call-summary.jsx": [
		693,
		9,
		100
	],
	"./Pages/wip/paid-amount-added": [
		694,
		9,
		133
	],
	"./Pages/wip/paid-amount-added.jsx": [
		694,
		9,
		133
	],
	"./Pages/wip/payment-review": [
		613,
		9,
		0,
		9
	],
	"./Pages/wip/payment-review.jsx": [
		613,
		9,
		0,
		9
	],
	"./Pages/wip/response-analysis": [
		611,
		9,
		34
	],
	"./Pages/wip/response-analysis.jsx": [
		611,
		9,
		34
	],
	"./Pages/wip/response-report": [
		695,
		9,
		84
	],
	"./Pages/wip/response-report.jsx": [
		695,
		9,
		84
	],
	"./Pages/wip/settlement-letter-analysis": [
		696,
		9,
		12
	],
	"./Pages/wip/settlement-letter-analysis.jsx": [
		696,
		9,
		12
	],
	"./Pages/wip/todays-activity": [
		697,
		9,
		85
	],
	"./Pages/wip/todays-activity.jsx": [
		697,
		9,
		85
	],
	"./Pages/wip/urgent-daily-campaign": [
		608,
		9,
		75
	],
	"./Pages/wip/urgent-daily-campaign.jsx": [
		608,
		9,
		75
	],
	"./Pages/wip/whatsapp-template-media": [
		651,
		9,
		65
	],
	"./Pages/wip/whatsapp-template-media.jsx": [
		651,
		9,
		65
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 970;
module.exports = webpackAsyncContext;